import { isValidCNPJ, isValidCPF } from "./index";

// Regras dos dois cadastros públicos: o da empresa (/sign-up) e o do colaborador pelo
// convite (/register/e/:token).

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function passwordRequirements(password) {
  return [
    { label: "Mínimo de 8 caracteres", valid: password.length >= 8 },
    { label: "Pelo menos uma letra maiúscula", valid: /[A-Z]/.test(password) },
    { label: "Pelo menos uma letra minúscula", valid: /[a-z]/.test(password) },
    { label: "Pelo menos um número", valid: /[0-9]/.test(password) },
    { label: "Pelo menos um caractere especial", valid: /[!@#$%^&*(),.?":{}|<>]/.test(password) },
  ];
}

const passwordOk = (password) => passwordRequirements(password).every((req) => req.valid);

/** CPF com 11 dígitos, CNPJ com 14: `null` quando o documento vale. */
export function documentError(document) {
  const digits = document.replace(/\D/g, "");
  if (digits.length === 11) return isValidCPF(document) ? null : "CPF inválido: confira os números.";
  if (digits.length === 14) return isValidCNPJ(document) ? null : "CNPJ inválido: confira os números.";
  return "Informe o CPF ou o CNPJ.";
}

/** Erros por id do campo, na ordem da tela. */
export function validateCompanySignUp({ name, cnpj, email, pass }) {
  const errors = {};
  if (!name.trim()) errors["sign-up-name"] = "Informe o nome da empresa.";
  if (!isValidCNPJ(cnpj)) errors["sign-up-cnpj"] = "CNPJ inválido: confira os números.";
  if (!isValidEmail(email)) errors["sign-up-email"] = "E-mail inválido.";
  if (!passwordOk(pass)) errors["sign-up-pass"] = "A senha não atende a todos os requisitos.";
  return errors;
}

/** Erros por id do campo, na ordem da tela. WhatsApp é opcional. */
export function validateEmployeeSignUp({ name, document, phone, email, pass }) {
  const errors = {};
  if (!name.trim()) errors["invite-name"] = "Informe seu nome completo.";
  const docError = documentError(document);
  if (docError) errors["invite-document"] = docError;
  if (phone && phone.replace(/\D/g, "").length < 10) errors["invite-phone"] = "Número de WhatsApp inválido.";
  if (!isValidEmail(email.trim())) errors["invite-email"] = "E-mail inválido.";
  if (!passwordOk(pass)) errors["invite-pass"] = "A senha não atende a todos os requisitos.";
  return errors;
}

/**
 * Por que o convite não abre. `retry`: falha ao validar, não um convite ruim; o
 * Auth.Service devolve `reason: "error"` quando a chamada falha.
 */
export function invitationError(result) {
  if (result?.reason === "expired") {
    return { title: "Este link de convite expirou", description: "Solicite um novo link ao administrador da empresa." };
  }
  if (result?.reason === "error") {
    return {
      title: "Não foi possível validar o convite",
      description: "Confira sua conexão e tente de novo.",
      retry: true,
    };
  }
  return {
    title: "Este link de convite é inválido ou já foi utilizado",
    description: "Entre em contato com o administrador da empresa para obter um novo link.",
  };
}
